import { AxiosInstance } from 'axios';

import { ServiceAccountsAPIApiFactory } from '@cast/openapi';

import { AXIOS_CONFIGURATION } from '../constants';

export const ServiceAccountsApiFactory = (client: AxiosInstance) => {
  const generatedApi = ServiceAccountsAPIApiFactory(
    AXIOS_CONFIGURATION,
    '',
    client
  );

  return {
    createServiceAccount: generatedApi.serviceAccountsAPICreateServiceAccount,
    updateServiceAccount: generatedApi.serviceAccountsAPIUpdateServiceAccount,
    createServiceAccountAccessKey:
      generatedApi.serviceAccountsAPICreateServiceAccountKey,
    deleteServiceAccounts: generatedApi.serviceAccountsAPIDeleteServiceAccounts,
    deleteServiceAccountAccessKey:
      generatedApi.serviceAccountsAPIDeleteServiceAccountKey,
    updateServiceAccountAccessKey:
      generatedApi.serviceAccountsAPIUpdateServiceAccountKey,
    getServiceAccount: generatedApi.serviceAccountsAPIGetServiceAccount,
    getServiceAccounts: generatedApi.serviceAccountsAPIListServiceAccounts,
    getServiceAccountKeys:
      generatedApi.serviceAccountsAPIListServiceAccountKeys,
    getOrganizationServiceAccountKeys:
      generatedApi.serviceAccountsAPIListOrganizationServiceAccountKeys,
  };
};
